// Module
var code = "<div class=\"mcp-contract-header\"> <label class=\"dc-label\">{{ctrl.title}}</label> </div> ";
// Exports
module.exports = code;